import { createContext } from 'react';

export const AttributeDefinitionsContext = createContext();
